import type { FoodMode, FoodRecommendation, JourneyMapSnapshot } from "@/shared/contracts";
import { ApiError } from "@/shared/api/errors";

/** Response-carried source only. Request fields never repair a missing response field. */
export function recommendationSourceMatches(rec: FoodRecommendation, petId: string | undefined, journeyId: string | null | undefined, fixture: boolean, mode?: FoodMode): boolean {
  if (!petId?.trim() || rec.pet_id !== petId || !rec.pet_id.trim() || (mode && rec.mode !== mode)) return false;
  if (fixture && rec.data_origin !== "fixture") return false;
  if (rec.mode === "owner_real_dining") return rec.journey_id === null;
  return rec.mode === "pet_virtual_explore" && typeof journeyId === "string" && Boolean(journeyId.trim()) && rec.journey_id === journeyId;
}

export function recommendationMatchesReader(rec: FoodRecommendation, snapshot: JourneyMapSnapshot | null, fixture: boolean): boolean {
  return Boolean(snapshot && recommendationSourceMatches(rec, snapshot.pet_id, snapshot.journey_id, fixture, "pet_virtual_explore")
    && typeof rec.itinerary_version === "number" && Number.isSafeInteger(rec.itinerary_version) && rec.itinerary_version >= 0 && rec.itinerary_version === snapshot.itinerary_version);
}

export const recommendationScopeError = () => new ApiError({ kind: "http", status: 409, code: "VERSION_CONFLICT", retryable: false, message: "这条推荐的来源或行程已经变化，请返回重新查看。" });
